import ParentUiState from "../../models/ParentUiState";

export function getAssignmentsFilterState(state: ParentUiState) {
  return state.assignmentsFilter;
}
